module.exports = __webpack_public_path__ + "static/media/champion04.61c17450.jpg";